import { X } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Button } from '..';
import { cn } from '@/lib';

export const PanelHeader = ({ title, badgeVariant, count, showClose = false, onClickChange, isGradient = false }) => {
  return (
    <div className="flex flex-row">
      <div className="px-4 py-2 font-medium w-fit flex items-center bg border-r border-border gap-2">
        <h1
          className={cn(
            'truncate max-w-full',
            isGradient && 'bg-gradient-to-r from-[#B6F4FF] via-[#6C94FF] to-[#A497FF] bg-clip-text text-transparent'
          )}
        >
          {title}
        </h1>
        {count && <Badge variant={badgeVariant ? badgeVariant : 'SolidPrimary'}>{count}</Badge>}
      </div>
      <div className="w-full bg-subtle border-b border-border flex flex-row items-center justify-end">
        {showClose && (
          <Button variant="ghost" size="ghostIcon" onClick={() => onClickChange(false)}>
            <X size={18} />
          </Button>
        )}
      </div>
    </div>
  );
};

PanelHeader.propTypes = {
  title: PropTypes.string.isRequired,
  badgeVariant: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
